const ON_CHANGE_DEBOUNCE_TIMER = 150; // Oct 22 2026: was 300; quantity changes feel quicker, rapid taps still batch

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
